import React from "react";
import "./Button.css";

const Button = ({ text, btnClass, href,target }) => {
  return (
    <a href={href} className={`btn ${btnClass}`} target={target}  >
      {text}
    </a>
  );
};

export default Button;
